// language=GraphQL
export const ALL_ESIM_SETTINGS_QUERY = `query Query($withRegions: Boolean = false) {
  esimSettings: allTravelEsimSettings {
    id
    enabled
    regions @include(if: $withRegions) {
      id
      name
      serviceCodePrefix
    }
  }
}`

// language=GraphQL
export const SINGLE_ESIM_SETTINGS_QUERY = `query Query($id: ID!, $withRegions: Boolean = false) {
  esimSettings: travelEsimSettings(id: $id) {
    id
    enabled
    regions @include(if: $withRegions) {
      id
      name
      serviceCodePrefix
    }
  }
}`

// language=GraphQL
export const CREATE_ESIM_SETTINGS_MUTATION = `
  mutation Mutation($input: CreateTravelEsimSettingsInput, $withRegions: Boolean = false) {
    esimSettings: createTravelEsimSettings(input: $input) {
      id
      enabled
      regions @include(if: $withRegions) {
        id
        name
        serviceCodePrefix
      }
    }
  }`

// language=GraphQL
export const UPDATE_ESIM_SETTINGS_MUTATION = `
  mutation Mutation($input: UpdateTravelEsimSettingsInput, $withRegions: Boolean = false) {
    esimSettings: updateTravelEsimSettings(input: $input) {
      id
      enabled
      regions @include(if: $withRegions) {
        id
        name
        serviceCodePrefix
      }
    }
  }`

// language=GraphQL
export const DELETE_ESIM_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteTravelEsimSettingsInput) {
    deleteTravelEsimSettings(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_ESIM_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteTravelEsimSettingsInput) {
    forceDeleteTravelEsimSettings(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_ESIM_SETTINGS_REGIONS_MUTATION = `
  mutation Mutation($input: addTravelEsimSettingsRegionsInput) {
    addTravelEsimSettingsRegions(input: $input) {
      id
      regionIds
    }
  }`

// language=GraphQL
export const REMOVE_ESIM_SETTINGS_REGIONS_MUTATION = `
  mutation Mutation($input: removeTravelEsimSettingsRegionsInput) {
    removeTravelEsimSettingsRegions(input: $input) {
      id
      regionIds
    }
  }`

// language=GraphQL
export const CREATE_ESIM_SETTINGS_REGIONS_MUTATION = `
  mutation Mutation($input: createTravelEsimSettingsRegionsInput) {
    createTravelEsimSettingsRegions(input: $input) {
      id
      regionIds
    }
  }`

// language=GraphQL
export const DELETE_ESIM_SETTINGS_REGIONS_MUTATION = `
  mutation Mutation($input: deleteTravelEsimSettingsRegionsInput) {
    deleteTravelEsimSettingsRegions(input: $input) {
      id
      regionIds
    }
  }`

// language=GraphQL
export const UPDATE_ESIM_SETTINGS_REGIONS_ORDER_MUTATION = `
  mutation Mutation($input: updateTravelEsimSettingsRegionsOrderInput) {
    updateTravelEsimSettingsRegionsOrder(input: $input) {
      id
      regionIds
    }
  }`

// language=GraphQL
export const ESIM_SETTINGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravelPricings: Boolean = false) {
  groupedDependents: travelEsimSettingsDependents(id: $id) {
    travelPricings @include(if: $withTravelPricings) {
      id
      isTravelDocumentationAvailable
    }
  }
}`
